module.exports = __webpack_public_path__ + "img/qr-code-1.4937d9cc.png";